import { TextOverflowTooltip } from '@ipfabric/ui-components/Tooltip/TextOverflowTooltip';
import { prop } from '@ipfabric/utils/fp/prop';
import { TableActions } from 'components/Table/components/TableActions';
import { useTableContextSelectors } from 'components/Table/model/TableModel';
import type { FC } from 'react';

export const TableTitleWithActions: FC = () => {
  const ctxProps = useTableContextSelectors({
    title: prop('title'),
    titleEndAdornment: prop('titleEndAdornment'),
  });
  // To render the titleEndAdornment next to the title and preserve the TextOverflowTooltip functionality,
  // it seems to be the only way to use only a single level of flexbox for the title, adornment and actions.
  // Failed all attempts to nest the title and adornment into another flexbox, making more logical
  // definition of left/right part and gaps between of the table title.
  return (
    <div className='flex flex-row items-center p pb-xs h-16'>
      <TextOverflowTooltip className='text-level-5 font-semibold flex-[0_1_auto]'>
        {ctxProps.title}
      </TextOverflowTooltip>
      {ctxProps.titleEndAdornment}
      {/* Fill remaining space with ensured minimum size gap there (justify-between like) */}
      <div className='flex-1 mr' />
      <TableActions />
    </div>
  );
};
